// Version : 1.0.0
// Author : AGALYA

import { takeLatest, put, all, call } from 'redux-saga/effects';
import HouseDetailsActionType from './house-details.types';
import {
	houseCreateSuccess,
	houseCreateFailure,
	houseResponseChanged,
} from './house-details.action';
import { encryptData } from '../../../_common/enode-decode';
import AlertManager from '../../../../utils/alertManager';
import { houseMemberDetailsAdd } from './house-details.service';

/** ***************** update House Details Start ************************/
export function* AddHouseDetails({ payload }: any) {
	try {
		const key = 'AddMemberHouseDetails';
		const {
			companyID,
			databaseName,
			memberID,
			houseType,
			landValue,
			landSize,
			durationOfStay,
			assetsType,
			noOfRooms,
			facilityType,
			havingAgriculturalLand,
			agriculturalLandValue,
			incomeFromAgriculturalLand,
			havingLivestock,
			incomeFromLiveStock,
			userID,
		} = payload;

		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			MemberID: memberID,
			HouseType: houseType,
			LandValue: landValue,
			LandSize: landSize,
			DurationOfStay: durationOfStay,
			AssetsType: assetsType,
			NoOfRooms: noOfRooms,
			FacilityType: facilityType,
			HavingAgriculturalLand: havingAgriculturalLand,
			AgriculturalLandValue: agriculturalLandValue,
			IncomeFromAgriculturalLand: incomeFromAgriculturalLand,
			HavingLivestock: havingLivestock,
			IncomeFromLiveStock: incomeFromLiveStock,
			OfficerID: userID,
			Secratekey: key,
		};

		const verifyData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(houseMemberDetailsAdd, verifyData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(houseCreateFailure(responseData.data));
		} else {
			yield put(houseCreateSuccess(responseData.data));
		}
	} catch (error) {
		yield put(houseCreateFailure(error));
	}
}

export function* AddHouseDetailsResponseClear() {
	yield put(houseResponseChanged());
}

export function* onHouseDetailsAddStart() {
	yield takeLatest(HouseDetailsActionType.HOUSE_DETAILS_CREATE_START, AddHouseDetails);
}

export function* onHouseDetailsAddResponseRest() {
	yield takeLatest(
		HouseDetailsActionType.HOUSE_DETAILS_CREATE_RESPONSE_REST_START,
		AddHouseDetailsResponseClear,
	);
}
/** ***************** update House Details End ************************/

export function* houseDetailsSaga() {
	yield all([call(onHouseDetailsAddStart), call(onHouseDetailsAddResponseRest)]);
}
